import StoreZoneDevice from '../../models/ZoneDevice'

/** @param {string | string[] | null | undefined} ids */
export const resolveZoneIdFromFetchIds = ids => {
  if (Array.isArray(ids)) {
    return ids[0]
  }
  return ids
}

/** @param {import('../../models/ZoneDevice').default[]} zoneDevices */
export const zoneDevicesToStoreBucket = zoneDevices => zoneDevices.map(zd =>
  typeof zd.toJSON === 'function' ? zd.toJSON() : StoreZoneDevice.FromJSON(zd).toJSON()
)
